import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

const initScrollSmoother = () => {

    let smoother = ScrollSmoother.create({
        smooth: 1,
        effects: true,
        // smoothTouch: 0.1,
        // normalizeScroll: true
    });

    document.querySelectorAll('.c-scroll-down').forEach(trigger => {
        trigger.addEventListener('click', () => {
            smoother.scrollTo('#intro', true, 'top top+=5%');
        });
    });

}

export { initScrollSmoother }